import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from 'components/ui/accordion';
import { AboutBadge } from '../AboutBadge';

const faqs = [
  {
    question: 'Что такое SMRHub?',
    answer: 'SMRHub - это платформа для строительных материалов и услуг.',
  },
  {
    question: 'Как зарегистрироваться в SMRHub?',
    answer: 'Вы можете зарегистрироваться, перейдя на страницу регистрации.',
  },
  {
    question: 'Как продать строительные материалы на SMRHub?',
    answer: 'Создайте учетную запись и добавьте свои товары в каталог.',
  },
];

export function SectionFAQ() {
  return (
    <section className="bg-white rounded-3xl sm:rounded-[48px] p-4 sm:p-6 md:p-10 m-2 sm:m-4 relative z-[1]">
      <div className="px-0 sm:px-8 md:px-16 lg:px-[100px]">
        <AboutBadge text="FAQ" />
        <div className="mt-6 sm:mt-8">
          <Accordion type="single" collapsible>
            {faqs.map((faq, index) => (
              <AccordionItem
                value={String(index)}
                key={index}
                className="mb-3 border border-gray-200 rounded-xl overflow-hidden bg-white hover:border-[#2f54eb]/30 transition-colors"
              >
                <AccordionTrigger className="text-sm sm:text-base font-semibold text-white bg-[#2f54eb] hover:bg-[#2646c7] px-4 sm:px-6 py-3 sm:py-4 text-left hover:no-underline transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm sm:text-base text-[#697180] px-4 sm:px-6 py-3 sm:py-4 bg-gray-50">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
